export interface IModelPresetResponse {
  id: number;
  name: string;
  modelName: string;
  tools: string[];
  knowledgeBase: string[];
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ModelPreset {
  id: number;
  name: string;
  modelName: string;
  toolList: string[];
  knowledgeBaseList: string[];
  createdAt: string | Date;
  updatedAt: string | Date;

  constructor(props = {} as IModelPresetResponse) {
    this.id = props.id;
    this.name = props.name;
    this.modelName = props.modelName;
    this.toolList = props.tools || [];
    this.knowledgeBaseList = props.knowledgeBase || [];
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
  }
}